<template>
  <in-viewport>
    <div class="consultancy-section">
      <base-layout hide-sidebar>
        <border-box slot="sidebar"><h2 v-html="heading"/></border-box>
        <div slot="content">
          <border-box>
            <div class="consultancy-section__content" v-html="content"/>
          </border-box>
          <border-box>
            <img class="consultancy-section__photo" alt="" :src="photo">
          </border-box>
        </div>
      </base-layout>
    </div>
  </in-viewport>
</template>

<script>
import BaseLayout from '@/components/BaseLayout'
import BorderBox from '@/components/BorderBox'

export default {
  components: {
    BaseLayout,
    BorderBox
  },
  props: {
    heading: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    photo: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
  .consultancy-section {
    &__content {
      @include text;
      @include vertical-space((bottom: 1), padding);

      @include media-up(lg) {
        @include nested-column-width(8, 9, lg);
      }
      @include media-up(lg) {
        margin-top: 17px;
      }

      /deep/ p:not(:last-child) {
        @include vertical-space((bottom: 1));
      }
    }

    &__photo {
      @include responsive-img;
      @include vertical-space((top: 1, bottom: 2), padding);
      @include media-up(lg) {
        @include nested-column-width(8, 9, lg);
      }
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/About/ConsultancySection.vue